import { useRbacNavDisabledWithReason } from 'hooks/useRbacNavCheck'
import { buildTranslate } from 'locales'
import React from 'react'
import NavLink from '../Bar/NavLink'

const t = buildTranslate('nav.campaigns_menu')

type Props = {
  isLeftNav?: boolean
  onClick?: () => void
}

const CampaignsContent = (props: Props) => {
  const { isLeftNav = false, onClick = () => {} } = props
  const allCampaigns = useRbacNavDisabledWithReason('AllCampaigns')
  const perfReport = useRbacNavDisabledWithReason('CampaignPerformanceReport')

  return (
    <>
      <NavLink
        isLeftNav={isLeftNav}
        onClick={onClick}
        text={t('all_campaigns')}
        link="/thanx_campaigns"
        disabled={allCampaigns.disabled}
        disabledReason={allCampaigns.disabledReason}
      />
      <NavLink
        isLeftNav={isLeftNav}
        onClick={onClick}
        text={t('performance')}
        link="/thanx_campaigns/performance"
        status="new"
        disabled={perfReport.disabled}
        disabledReason={perfReport.disabledReason}
      />
    </>
  )
}

export default CampaignsContent
